export const YoutubeEmbed = ({ embedId }: { embedId: string }) => (
  <div style={{ paddingBottom: "300px" }} className="video-responsive">
    <iframe
      style={{ maxHeight: "300px" }}
      width="853"
      height="480"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);
